<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                :class="`fa ${icon} fa-lg icon-button`"
                :title="btnTitulo"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal id="modalMostrarConteudo" v-model="mostrarModal" @show="preencherForm()" size="lg">
            <div slot="modal-title">{{ titulo }}</div>
            <b-row>
                <b-col sm="12">
                    <span v-if="tipo === 'T'">{{ conteudo }}</span>
                    <span v-if="tipo === 'X'">{{ conteudo }}</span>
                    <vue-json-pretty
                        v-if="tipo === 'J' && conteudo !== 'n/a'"
                        :data="JSON.parse(conteudo)"
                        :showDoubleQuotes="false"
                    ></vue-json-pretty>
                    <span v-if="tipo === 'J' && conteudo === 'n/a'">{{ conteudo }}</span>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">Fechar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'

export default {
	components: {
		VueJsonPretty
	},

	props: {
		conteudo: {
			type: String,
			default: () => ''
		},

		titulo: {
			type: String,
			default: () => ''
		},

		btnTitulo: {
			type: String,
			default: () => ''
		},

		icon: {
			type: String,
			default: () => ''
		},

		tipo: {
			type: String,
			default: () => ''
		}
	},

	data() {
		return {
			mostrarModal: false
		}
	},

	methods: {
		abrirModal() {
			this.mostrarModal = true
		},

		fecharModal() {
			this.mostrarModal = false
		},

		preencherForm() {}
	},

	created() {},

	computed: {},

	watch: {}
}
</script>
